import { initTagManager, sendEvent } from '@skyscanner-internal/gtm-client';
import logger from 'saddlebag-logger';

import { EVENT_TYPE, namespace } from './gtm-events';

import type { GoogleTagManagerProps } from '@shared/types/client-side-params';

const loadGtmClient = (gtmProps: GoogleTagManagerProps) => {
  try {
    initTagManager(gtmProps.market);
    const eventName = EVENT_TYPE[gtmProps.pageType] || gtmProps.pageType;
    sendEvent({ event: eventName as any, ...gtmProps });
  } catch (error: any) {
    logger.logError(error, {
      message: `Failed to load gtmClient on ${namespace}: ${error.message}`,
      component: namespace,
    });
  }
};

export default loadGtmClient;
